export function sortReferentialByTranslation( referential = [], language ) {
    return [ ...referential ].sort( ( firstItem, secondItem ) => {
        const firstLabel = firstItem?.translations?.[ language ] || "";
        const secondLabel = secondItem?.translations?.[ language ] || "";

        if ( !firstLabel && !secondLabel ) return 0;
        if ( !firstLabel ) return 1;
        if ( !secondLabel ) return -1;

        return firstLabel.localeCompare( secondLabel, language, { sensitivity: "base" } );
    } );
}
